import { Component, Input } from '@angular/core';

import { TargetChoicesEnum } from '../../../enums';

@Component({
    selector: 'app-prevent-back-modal',
    templateUrl: './prevent-back-modal.component.html',
    styleUrls: ['./prevent-back-modal.component.scss'],
})
export class PreventBackModalComponent {
    @Input() public currentTarget: TargetChoicesEnum;

    public targetChoicesEnum = TargetChoicesEnum;
}
